var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1911_14072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FF982E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1911_14072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1663 76.9999C54.1663 79.3009 52.3009 81.1663 49.9999 81.1663C47.6989 81.1663 45.8335 79.3009 45.8335 76.9999C45.8335 74.6989 47.6989 72.8335 49.9999 72.8335C52.3009 72.8335 54.1663 74.6989 54.1663 76.9999Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5956 54.675C55.1208 55.354 54.1664 56.8417 54.1664 58.4629V60.3337C54.1664 62.6332 52.3041 64.5001 50 64.5001C47.6959 64.5001 45.8336 62.6332 45.8336 60.3337V58.4629C45.8336 53.6 48.6916 49.1421 53.1044 47.1043C57.3502 45.1504 60.4164 39.9624 60.4164 37.4165C60.4164 31.6754 55.7457 27.0001 50 27.0001C44.2543 27.0001 39.5836 31.6754 39.5836 37.4165C39.5836 39.7168 37.7205 41.5837 35.4164 41.5837C33.1123 41.5837 31.25 39.7168 31.25 37.4165C31.25 27.0794 39.6622 18.6665 50 18.6665C60.3378 18.6665 68.75 27.0794 68.75 37.4165C68.75 43.0462 63.8664 51.3211 56.5956 54.675Z",
    fill: "#FAFAFA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1911_14072",
    x: 31.25,
    y: 18.6665,
    width: 41.5,
    height: 66.4998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1911_14072"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1911_14072",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1911_14072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.454efe1b78d061dc276b9ed2ed48bdc5.svg";
export { ForwardRef as ReactComponent };